<template>
  <v-flex>
    <DatePicker
      label="Data Início"
      :max="new Date().toISOString().substring(0, 10)"
      v-model="startDate"
      :initialDate="false"
      outline
    />
    <DatePicker
      label="Data Fim"
      :max="new Date().toISOString().substring(0, 10)"
      v-model="endDate"
      :initialDate="false"
      outline
    />
  </v-flex>
</template>
<script>
/*
LogDateFilter

Props: logs: Array[Log]
Emits: filtered: Array[log]
       filterMap: Array[Boolean] || null

Returns an array of booleans representing which logs are included in the selected Dates.
*/
import DatePicker from '@/components/inputs/DatePicker'

export default {
  props: {
    logs: { type: Array, default: () => [] }
  },
  components: {
    DatePicker
  },
  data: () => ({
    startDate: null,
    endDate: null
  }),
  computed: {
    filterMap() {
      if (this.startDate || this.endDate) {
        return this.logs.map(log => this.dateBetween(log['entry-date']))
      } else {
        return null
      }
    },
    filteredLogs() {
      if (this.filterMap === null) return this.logs

      const returnedLogs = []
      for (let i = 0; i < this.filterMap.length; i++) {
        if (this.filterMap[i]) {
          returnedLogs.push(this.logs[i])
        }
      }
      return returnedLogs
    }
  },
  methods: {
    emitChanges() {
      this.$emit('filtered', this.filteredLogs)
      this.$emit('filterMap', this.filterMap)
    },
    dateBetween(logDate) {
      return (
        (!this.startDate || logDate >= this.startDate) &&
        (!this.endDate || logDate <= this.endDate)
      )
    }
  },
  watch: {
    startDate() {
      this.emitChanges()
    },
    endDate() {
      this.emitChanges()
    }
  },
  created() {
    this.emitChanges()
  }
}
</script>
